// src/data/bookArticleDetailFields.js

export const quickFactFields = [
  {
    key: "publisher",
    labelKey: "book.quickFactLabels.publisher",
  },
  {
    key: "format",
    labelKey: "book.quickFactLabels.format",
  },
  {
    key: "language",
    labelKey: "book.quickFactLabels.language",
  },
  {
    key: "type",
    labelKey: "book.quickFactLabels.type",
  },
];

export const bibliographicFieldsLeft = [
  {
    key: "title",
    labelKey: "book.detailFields.title",
  },
  {
    key: "alternative",
    labelKey: "book.detailFields.alternative",
  },
  {
    key: "creator",
    labelKey: "book.detailFields.creator",
  },
  {
    key: "contributor",
    labelKey: "book.detailFields.contributor",
  },
  {
    key: "publisher",
    labelKey: "book.detailFields.publisher",
  },
  {
    key: "date",
    labelKey: "book.detailFields.date",
  },
  {
    key: "subject",
    labelKey: "book.detailFields.subject",
  },
];

export const bibliographicFieldsRight = [
  {
    key: "language",
    labelKey: "book.detailFields.language",
  },
  {
    key: "type",
    labelKey: "book.detailFields.type",
  },
  {
    key: "format",
    labelKey: "book.detailFields.format",
  },
  {
    key: "identifier",
    labelKey: "book.detailFields.identifier",
  },
  {
    key: "source",
    labelKey: "book.detailFields.source",
  },
  {
    key: "relation",
    labelKey: "book.detailFields.relation",
  },
  {
    key: "coverage",
    labelKey: "book.detailFields.coverage",
  },
];